import {
  RoundingSettingCategoryConfig,
  type RoundingSettingCategory,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';

export const RoundingSettingCategoryItem: RelationFieldProps<RoundingSettingCategory> =
  {
    nested: [],
    filters: [],
    renderItem: (item) => ({
      title: item.title ?? item.id,
      badge: undefined,
      descriptionItems: RoundingSettingCategoryConfig.verboseName,
    }),
  };
